// extracted by mini-css-extract-plugin
export default {"icon":"BaseIcon_icon__EucFf"};